export enum CancellationStatus {
	Success = "Successful",
	Error = "Error",
	Pending = "Pending"
}

export enum CancelResponses {
	Success = "OrderSuccessResponse",
	Pending = "OrderInProgressResponse"
}

export enum OrderFlow {
	HomeEmptyOrders = "home_empty_orders",
	HomeEmptyOrdersGrouped = "home_empty_orders_grouped",
	TradeSheet = "trade_tab",
	OrdersList = "orders_list",
	OrderDetails = "order_details",
	Adp = "adp_trade",
	AdpLimitOrders = "adp_widget",
	AdpCreateOrder = "adp_create_lo_pill",
	AdpCreateOrderGrouped = "adp_create_lo_pill_grouped",
	AdpGrouped = "adp_widget_grouped",
	HomeGrouped = "home_screen_grouped",
	Watchlist = "watchlist",
	DiscoveryPrices = "discovery_prices",
	DiscoveryHighLights = "discovery_highlights",
	TradeMoreHistory = "trade_more_history",
	AdpMore = "adp_more",
	VisionUpSellBanner = "vision_upsell_banner",
	AdpMarginWidget = "adp_margin_widget",
	PortfolioPositionDetail = "portfolio_margin_position_details",
	HomeMarginWidget = "home_margin_widget",
	MarginSuccessScreen = "margin_success_screen",
	CancelledLimitOrderDetails = "cancelled_limit_order_details"
}
